import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import IntegratedHealthcarePage from "./pages/IntegratedHealthcarePage";
import ServicesPage from "./pages/ServicesPage";
import DrKumarProfilePage from "./pages/DrKumarProfilePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import CompliancePage from "./pages/CompliancePage";
import CareersPage from "./pages/CareersPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/integrated-healthcare" element={<IntegratedHealthcarePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/dr-kumar-profile" element={<DrKumarProfilePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
